// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "accompanying-2aZYu";
var _4 = "accompanying__header-1hqYN";
var _5 = "accompanying__info-2zwFK";
var _6 = "formControl__label-1SRIn";
var _7 = "formControl__checkbox-1A6xs";
var _8 = "checkbox__checked-3c9aw";
var _9 = "fields-N4DS4";
var _a = "error-2QHVn";
var _b = "checkbox-3dGff";
export { _1 as "__esModule", _2 as "mobile", _3 as "accompanying", _4 as "accompanying__header", _5 as "accompanying__info", _6 as "formControl__label", _7 as "formControl__checkbox", _8 as "checkbox__checked", _9 as "fields", _a as "error", _b as "checkbox" }
export default { "__esModule": _1, "mobile": _2, "accompanying": _3, "accompanying__header": _4, "accompanying__info": _5, "formControl__label": _6, "formControl__checkbox": _7, "checkbox__checked": _8, "fields": _9, "error": _a, "checkbox": _b }
